/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SINGLE_ACC_REC_NDC_TABLE = 'SINGLE_ACC_REC_NDC_TABLE';
export const SINGLE_ACC_REC_FIELD_VALUES = 'SINGLE_ACC_REC_FIELD_VALUES';
export const QAR_BALANCE_DUE = 'QAR_BALANCE_DUE';
export const QAR_OVERRIDDEN = 'QAR_OVERRIDDEN';
export const QAR_PAID_FULL = 'QAR_PAID_FULL';
export const AR_QTR_ACCOUNT_REC_FIELD_CLEAR_REDUX =
  'AR_QTR_ACCOUNT_REC_FIELD_CLEAR_REDUX';
